import React, { Fragment, useState } from "react";
import T from "prop-types";
import { Map } from "immutable";
import { Col } from "react-bootstrap";
import { Field, Fields, FormSection } from "redux-form";
import { RadioGroupField } from "MODULES/shared/components/Forms";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import { ShippingMethod } from "MODULES/shared/components/Forms/FormSections";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { properCase } from "LIB/formatters/text";
import { RETURN_TO_TYPE, SHIP_TO, SHIP_TO_TYPE } from "APP_ROOT/constants";
import { shipToOptions } from "./shippingTypes";
import ShipToFields from "./ShipToFields";

function ShippingSection({
  copyBillingAddress,
  getField,
  shipToCustomer,
  shipToCompany,
  shippingType,
  children,
  setFieldValue,
  setFOB,
  return_to_type: returnToType,
  ship_to_type: shipToType,
  wtDimsReq,
  beforeShippingMethod,
  setShippingToAddress,
  convertSO,
  preferredShippingMethods,
  ...props
}) {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const shipTypeInput = shippingType === SHIP_TO ? shipToType : returnToType;

  const handleSelectChange = event => {
    const methodId = event.target.value;
    const method = preferredShippingMethods.find(
      m => m.id.toString() === methodId
    );
    setSelectedMethod(method);
  };

  const shippingMethodOptions = preferredShippingMethods.map(method => ({
    label: `
      CARRIER: ${method.carrier.toUpperCase()}
      - METHOD: ${method.shipping_method.replace(/_/g, " ").toUpperCase()}
      - ACCOUNT #: ${method.account_number || "N/A"}`,
    value: method.id.toString()
  }));

  return (
    <div>
      <FormRow>
        <Col xs={12}>
          <Field
            discreet={props.discreet}
            name={`${shippingType}_type`}
            component={RadioGroupField}
            options={props.shipToOptions || shipToOptions}
            label={shippingType === SHIP_TO ? properCase(SHIP_TO) : "Return To"}
            required
          />
        </Col>
      </FormRow>
      {shippingMethodOptions.length > 0 &&
        shippingMethodOptions.length !== 1 && (
          <FormRow style={{ marginBottom: "15px" }}>
            <Col xs={12}>
              <label htmlFor="preferred_shipping_method">
                Preferred Shipping Methods
              </label>
              <select className="form-control" onChange={handleSelectChange}>
                <option value="">Select one</option>
                {shippingMethodOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </Col>
          </FormRow>
        )}
      <Fields
        copyBillingAddress={copyBillingAddress}
        component={ShipToFields}
        getFieldValue={getField}
        names={[`${shippingType}_type`]}
        shipToType={shipTypeInput.input.value}
        setFieldValue={setFieldValue}
        setFOB={setFOB}
        shipToCompany={shipToCompany}
        shipToCustomer={shipToCustomer}
        setShippingToAddress={setShippingToAddress}
      />
      {convertSO && (
        <FormSection name={`${shippingType}_shipping_method`}>
          <ShippingMethod
            wtDimsReq={wtDimsReq}
            selectedCarrier={selectedMethod ? selectedMethod.carrier : ""}
            selectedShippingMethod={
              selectedMethod ? selectedMethod.shipping_method : ""
            }
            selectedAccountNumber={
              selectedMethod ? selectedMethod.account_number : ""
            }
          />
        </FormSection>
      )}
      <hr className="hr-sm hr-dashed margin-top-none" />
      {beforeShippingMethod && (
        <Fragment>
          {beforeShippingMethod}
          {!convertSO && <hr className="hr-sm hr-dashed margin-top-none" />}
        </Fragment>
      )}
      {!convertSO && (
        <FormSection name={`${shippingType}_shipping_method`}>
          <ShippingMethod
            wtDimsReq={wtDimsReq}
            selectedCarrier={selectedMethod ? selectedMethod.carrier : ""}
            selectedShippingMethod={
              selectedMethod ? selectedMethod.shipping_method : ""
            }
            selectedAccountNumber={
              selectedMethod ? selectedMethod.account_number : ""
            }
          />
        </FormSection>
      )}
      {children}
    </div>
  );
}

ShippingSection.defaultProps = {
  shippingType: SHIP_TO,
  shipToCompany: Map(),
  shipToCustomer: Map(),
  beforeShippingMethod: null,
  preferredShippingMethods: []
};

ShippingSection.propTypes = {
  copyBillingAddress: T.func,
  discreet: T.bool,
  getField: T.func,
  shippingType: T.string.isRequired,
  setFieldValue: T.func,
  setFOB: T.func,
  setShippingToAddress: T.func,
  children: T.oneOfType([T.node, T.arrayOf(T.node)]),
  shipToCompany: T.instanceOf(Object),
  shipToCustomer: T.instanceOf(Object),
  return_to_type: F.formField(F.stringInput).isRequired,
  ship_to_type: F.formField(F.stringInput).isRequired,
  shipToOptions: T.arrayOf(T.string),
  wtDimsReq: T.bool,
  beforeShippingMethod: T.node,
  preferredShippingMethods: T.arrayOf(T.instanceOf(Object))
};

export default withFormFields(ShippingSection, [SHIP_TO_TYPE, RETURN_TO_TYPE]);



// WEBPACK FOOTER //
// ./app/modules/shared/components/ShippingSection/ShippingSection.jsx